// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AvatarManagement-base__gyQtb{position:relative;display:flex;flex-direction:column;align-items:center;width:var(--size-full);padding-top:var(--size-5)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "AvatarManagement-base__gyQtb"
};
export default ___CSS_LOADER_EXPORT___;
